import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import Footer from '../Footer/FooterContainer';
import Loading from '../Loading/LoadingView';
import { isNumeric } from '../../../js/app/react/validators';
import PlanImpact from '../PlanImpact/PlanImpactContainer';
import WHAT_IFS_DICTIONARY from '../WhatIfsComponentDictionary';

class View extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId,
      fpId,
      goalId,
      whatIf,
      fetchInitialPlanImpact,
      whatIfTemplate,
      hasPlanImpact,
      fetchPlanImpact,
    } = this.props;

    const impactTriggerProps = ['whatIf'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      if (hasPlanImpact) {
        fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
      } else {
        fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
      }
    }
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      hasPlanImpact,
      planImpactItems,
      currentView,
    } = this.props;
    let Content = null;
    if (isNumeric(currentView) && WHAT_IFS_DICTIONARY[currentView]) {
      const WhatIfView = WHAT_IFS_DICTIONARY[currentView];
      Content = <WhatIfView clientId={clientId} />;
    }
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        {Content}
        {hasPlanImpact && <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />}
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
View.defaultProps = {
  currentView: null,
};

View.propTypes = {
  goalId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  clientId: PropTypes.number.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  currentView: PropTypes.number,
  hasPlanImpact: PropTypes.bool.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default View;
